import { combineReducers } from '@reduxjs/toolkit';
import { dealersReducer } from '@yme/common/redux/dealers';
import { reducer as terminalOnlineReducer } from '@yme/components/CheckoutForm/PaymentForm/PaymentOptions/TerminalOnline/redux/reducer';
import { reducer as cycleSchemeReducer } from '@yme/components/CheckoutForm/PaymentForm/PaymentOptions/redux/reducer';
import { reducer as GoogleLocationSearchReducer } from '@yme/components/CheckoutForm/ShippingDetailsForm/PreferredDealer/GoogleLocationSearch/redux/reducers';
import { reducer as checkoutFormReducer } from '@yme/components/CheckoutForm/redux/reducers';
import { reducer as ContentHeroPageReducer } from '@yme/components/ContentPage/components/HeroSection/redux/reducers';
import { reducer as dealerLocatorReducer } from '@yme/components/DealerLocator/redux/reducers';
import { reducer as destinationsReducer } from '@yme/components/Destinations/redux/reducers';
import { reducer as newsEventsArticlesReducer } from '@yme/components/NewsPage/components/NewsEventsGrid/redux/reducer';
import { reducer as checkoutPrivacyConsentReducer } from '@yme/components/PrivacyConsent/redux/checkout/reducers';
import { reducer as privacyConsentReducer } from '@yme/components/PrivacyConsent/redux/reducers';
import { reducer as productDetailsPageReducer } from '@yme/components/ProductDetailsPage/redux/reducer';
import { reducer as testRideReducer } from '@yme/components/TestRide/redux/reducers';
import { reducer as productCardReducer } from '@yme/pdp-components/ProductCard/redux/reducer';
import { reducer as productFeaturesReducer } from '@yme/pdp-components/ProductFeatures/redux/reducers';
import { reducer as cartReducer, reducerExternalCart as externalCartReducer, } from '../common/redux/cart/reducer';
import { reducer as commonReducer } from '../common/redux/common/reducer';
import { reducer as eInvoiceReducer } from '../components/CheckoutForm/ShippingDetailsForm/EInvoiceForm/redux/reducers';
import { reducer as nifNumberReducer } from '../components/CheckoutForm/ShippingDetailsForm/NIFNumber/redux/reducers';
import { reducer as comparisonProductsReducer } from '../components/Comparison/redux/reducer';
import { reducer as newsletterReducer } from '../components/Footer/Newsletters/redux/reducer';
import { reducer as footerReducer } from '../components/FooterBottomMenu/redux/reducers';
import { reducer as profileDataReducer } from '../components/Header/ProfileMenu/redux/reducer';
import { reducer as headerReducer } from '../components/Header/redux/reducers';
import { reducer as partsAccessoriesReducer } from '../components/PartsAccessories/redux/reducers';
import { reducer as fasletReducer } from '../components/ProductDetailsPage/components/Faslet/redux/reducer';
import { reducer as formsReducer } from '../forms/reducers';
import { reducer as modalsReducer } from '../modals/reducers';
export const rootReducer = combineReducers({
    dealers: dealersReducer,
    common: commonReducer,
    forms: formsReducer,
    modals: modalsReducer,
    header: headerReducer,
    footer: footerReducer,
    contentHeroPage: ContentHeroPageReducer,
    newsEventsArticles: newsEventsArticlesReducer,
    partsAccessories: partsAccessoriesReducer,
    dealerLocator: dealerLocatorReducer,
    productDetailsPage: productDetailsPageReducer,
    productCard: productCardReducer,
    productFeatures: productFeaturesReducer,
    profileData: profileDataReducer,
    comparisonProducts: comparisonProductsReducer,
    googleLocationSearch: GoogleLocationSearchReducer,
    cart: cartReducer,
    externalCart: externalCartReducer,
    checkout: checkoutFormReducer,
    eInvoice: eInvoiceReducer,
    nifNumber: nifNumberReducer,
    privacyConsent: privacyConsentReducer,
    checkoutPrivacyConsent: checkoutPrivacyConsentReducer,
    testRide: testRideReducer,
    destinations: destinationsReducer,
    newsletter: newsletterReducer,
    faslet: fasletReducer,
    cycleScheme: cycleSchemeReducer,
    terminalPayment: terminalOnlineReducer,
});
